<template>
  <div>
    <div>
      <MainPicture src="/static/img/home-big-img.webp" scrollTo="#main-content">
        <template v-slot:logo>
          <div class="header-group">
            <div class="logo-group">
              <img src="/static/img/BVF-logo.svg" alt="logo" />
              <p>Bob Vlake Foundation</p>
            </div>
            <small>
              De kracht van samenwerken
              <br />Voor een gezonde, leefbare toekomst
            </small>
          </div>
        </template>
      </MainPicture>
    </div>
    <div id="main-content" :key="entry.text" v-for="entry in texts">
      <TextContainer
        v-if="entry.text.length < 700"
        :src="entry.imgPath"
        v-bind:id="entry.id"
        v-bind:content="entry.text"
        v-bind:orientation="entry.orientation"
        v-bind:imageFooter="entry.imgFooter"
        v-bind:title="entry.title"
        v-bind:highlightedImage="entry.highlighted"
        v-on:showmodal="showModal"
      />

      <BigTextContainer
        v-else
        :src="entry.imgPath"
        v-bind:id="entry.id"
        v-bind:content="entry.text"
        v-bind:orientation="entry.orientation"
        v-bind:title="entry.title"
        v-bind:imageFooter="entry.imgFooter"
        v-bind:highlightedImage="entry.highlighted"
        v-on:showmodal="showModal"
      />
    </div>
    <TextModal v-show="modalShow" @close="closeModal">
      <template v-slot:header v-html="modalTitle">{{ modalTitle }}</template>
      <template v-slot:body v-html="modalContent">{{ modalContent }}</template>
    </TextModal>
  </div>
</template>

<script>
import MainPicture from "../components/MainPicture";
import TextContainer from "../components/TextContainer";
import BigTextContainer from "../components/BigTextContainer";
import TextModal from "../components/TextModal";

export default {
  name: "Home",
  components: {
    MainPicture,
    TextContainer,
    TextModal,
    BigTextContainer
  },
  mounted() {
    document.addEventListener("keydown", evt => {
      if (evt.key === "Escape") {
        this.closeModal();
      }
    });
  },
  data: function() {
    return {
      modalTitle: "",
      modalContent: "",
      modalShow: false,
      page: "home",
      texts: null,
      texts2: [
        {
          title: "Missie",
          text: `
                <p>De Bob Vlake Foundation (BVF) is ontstaan vanuit een missie om de samenleving te verbeteren door samen te werken aan projecten die maatschappelijke waarde toevoegen voor nu en de toekomst. De BVF wil dit bereiken door op een aantal gebieden bij te dragen aan diverse projecten door tijd en kennis van de ambassadeurs en financiële middelen van de Foundation.</p> <p>De Foundation streeft naar een gelijkwaardige en collectieve samenleving waarin verbinding is tussen verschillende groepen en geledingen. Iedereen wordt aangespoord om bij te dragen aan een gezonde en leefbare toekomst. Samen werken aan een gemeenschappelijk belang en maatschappelijke meerwaarde creëren door de volgende thema’s te ondersteunen:</p>
                <ul>
                <li>Gezondheid</li>
                <li>Educatie en talentontwikkeling</li>
                <li>Sociale betrokkenheid door sport</li>
                <li>Sociaal ondernemerschap</li>
                </ul>
                <p>De BVF werkt enkel in Nederland en staat open voor samenwerking rondom de hierboven genoemde en andere thema’s, passend binnen de doelstelling.</p>
                `,
          orientation: true,
          imgPath: "/static/img/mission.png"
        },
        {
          title: "Gezondheid",
          text: `Toenemende vergrijzing betekent een omvangrijker vraag naar zorg. Daarnaast is door het gebruik van internet en de toenemende invloed van de media, de samenleving steeds mondiger en wordt om persoonlijkere zorg gevraagd. Wij willen daarom bijdragen aan vernieuwingen die de zorg toegankelijker kunnen maken voor iedereen en hiermee verbeteren. Wij focussen ons op het vroegtijdig herkennen van de symptomen. Door techniek en innovatie willen wij de preventieve zorg een meer centrale plaats geven in het gezondheidssysteem. Hierdoor worden de kosten van de gezondheidszorg verlaagd.`,
          imgPath: "/static/img/health.png",
          orientation: true
        },
        {
          title: "Educatie en talentontwikkeling",
          text: `De kloof tussen hoog en laag opgeleid wordt steeds groter, en de vraag naar concrete en specifieke talenten neemt sterk toe. Er wordt onvoldoende gebruik gemaakt van deze (soms verborgen) talenten. We willen door middel van meer op hun behoeften toegesneden opleidingsmogelijkheden meer hun talenten tot ontwikkeling laten komen zodat ze hiermee een meer voldoening gevende plaats in de samenleving krijgen.`,
          imgPath: "/static/img/education.png",
          orientation: true
        },
        {
          title: "Sociale betrokkenheid door sport",
          text: `Helaas is sport in Nederland nog altijd niet voor iedereen toegankelijk, mede door de hieraan verbonden kosten. Wij vinden sport een belangrijk verbindend element in de maatschappij, waar iedereen toegang tot zou moeten hebben. Niet alleen omdat het je mentale en fysieke gezondheid verbetert, maar ook omdat je leert deel uit te maken van een samenleving in het klein.`,
          imgPath: "/static/img/sport.png",
          orientation: true
        },
        {
          title: "Sociaal ondernemerschap",
          text: `Sociale ondernemers opereren vanuit de visie dat hun werk vooral een bijdrage moet leveren aan een positieve ontwikkeling in de maatschappij. In de startperiode kan dit het verdienmodel bemoeilijken. Wij geloven dat deze ondernemensaanpak, waarin zowel mens, natuur als ondernemen een gelijkwaardige plek krijgen, de enige manier is. Omdat goede ideeën (voor zowel de maatschappij als de activiteit) vooral in het begin sneuvelen willen wij juist in deze eerste fase de ondernemer ondersteunen met kennis, ervaring en middelen.`,
          imgPath: "/static/img/entrepreneurship.png",
          orientation: true
        }
      ]
    };
  },
  methods: {
    showModal(title, cont) {
      this.modalTitle = title;
      this.modalContent = cont;
      this.modalShow = true;
    },
    closeModal() {
      this.modalShow = false;
      this.modalTitle = "";
      this.modalContent = "";
    }
  },
  created: function() {
    this.$api
      .get(`/maintext/page/${this.page}`)
      .then(response => (this.texts = response.data));
  }
};
</script>

<style lang="less" scoped>
.header-group {
  display: flex;
  flex-direction: column;
  text-align: left;

  small {
    margin-top: 16px;
    font-size: 1.2rem;
  }

  .logo-group {
    text-align: left;
    width: 250px;
    height: 5rem;
    display: flex;
    vertical-align: middle;

    p {
      margin: auto;
      line-height: 2.5rem;
      font-size: 3rem;
      text-transform: uppercase;
    }

    small {
      display: block;
    }

    img {
      margin: auto;
      height: 100%;
      margin-right: 8px;
    }
  }
}

@media screen and (max-width: 768px) {
  .logo-group {
    height: 2.5rem;
    p {
      line-height: 1.4rem;
      font-size: 1.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue